import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img className='h-10 w-auto' src="logo-white.png" alt="logo" />
            </div>
            <p className="footer-description">
              Fabricamos produtos para entusiastas da programação
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Produtos</h4>
              <ul>
                <li><a href="#python">Python</a></li>
                <li><a href="#java">Java</a></li>
                <li><a href="#cpp">C++</a></li>
                <li><a href="#c">C</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Empresa</h4>
              <ul>
                <li><a href="/about">Sobre</a></li>
                <li><a href="/contact">Contato</a></li>
                <li><a href="#careers">Carreiras</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Suporte</h4>
              <ul>
                <li><a href="#help">Ajuda</a></li>
                <li><a href="#docs">Documentação</a></li>
                <li><a href="#community">Comunidade</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Nacodara. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;